// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"1b8194b9","46":"b3561320","194":"f3c66f57","216":"5d46bf8c","274":"5f8402f5","434":"4a242892","555":"c86a6f41","632":"c6bf995c","677":"8a2afe22","773":"6a3c68c3","925":"31bd92c2","986":"96c3dda0"}[chunkId] + ".chunk.js";
};